import { Auth as AWSAuth, Hub } from "aws-amplify";

import { config } from "./config";
AWSAuth.configure(config.awsConfig);

export { AWSAuth, Hub };
